import React, { useState, useRef, useEffect } from 'react';
import '../../../styles/components/sections/DropdownFilter.css';

const LocationFilter = ({ cities, townships, selectedCity, selectedTownship, onCityChange, onTownshipChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Zatvori dropdown na klik van njega
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleCitySelect = (city) => {
    onCityChange(city);
    if (city !== 'Beograd') {
      setIsOpen(false);
    }
  };

  const handleTownshipSelect = (township) => {
    onTownshipChange(township);
    setIsOpen(false);
  };

  const getDisplayText = () => {
    if (selectedCity === 'Sve lokacije') return 'Sve lokacije';
    if (selectedCity === 'Beograd' && selectedTownship !== 'Sve opštine') {
      return selectedTownship;
    }
    return selectedCity;
  };

  return (
    <div className="dropdown-filter-wrapper">
      <div className="dropdown-filter" ref={dropdownRef}>
        <button 
          className={`dropdown-trigger ${isOpen ? 'active' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <svg className="filter-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 6H20M4 12H20M4 18H11" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <circle cx="17" cy="18" r="3" fill="currentColor"/>
          </svg>
          <span className="filter-text">{getDisplayText()}</span>
          <svg className={`arrow ${isOpen ? 'up' : ''}`} viewBox="0 0 12 8" fill="none">
            <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        {isOpen && (
          <div className="dropdown-menu">
            <div className="dropdown-section">
              <div className="dropdown-label">Gradovi</div>
              <div className="dropdown-items">
                {cities.map(city => (
                  <button
                    key={city}
                    className={`dropdown-item ${selectedCity === city ? 'active' : ''}`}
                    onClick={() => handleCitySelect(city)}
                  >
                    <span>{city}</span>
                    {selectedCity === city && <span className="checkmark">✓</span>}
                  </button>
                ))}
              </div>
            </div>

            {selectedCity === 'Beograd' && townships.length > 0 && (
              <div className="dropdown-section townships">
                <div className="dropdown-label">Beogradske opštine</div>
                <div className="dropdown-items">
                  {townships.map(township => (
                    <button
                      key={township}
                      className={`dropdown-item ${selectedTownship === township ? 'active' : ''}`}
                      onClick={() => handleTownshipSelect(township)}
                    >
                      <span>{township}</span>
                      {selectedTownship === township && <span className="checkmark">✓</span>}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationFilter;